module.exports = function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};



//////////////////
// WEBPACK FOOTER
// ./~/react-toolbox/~/ramda/src/internal/_has.js
// module id = 2843
// module chunks = 39